import { render, staticRenderFns } from "./WorkflowDlg.vue?vue&type=template&id=b8fc93a8&scoped=true"
import script from "./WorkflowDlg.vue?vue&type=script&lang=js"
export * from "./WorkflowDlg.vue?vue&type=script&lang=js"
import style0 from "./WorkflowDlg.vue?vue&type=style&index=0&id=b8fc93a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fc93a8",
  null
  
)

export default component.exports